import {load} from '@shopify/theme-sections';

import katiesStory from '../sections/katies-story';
import charity from '../sections/charity';
import meetTheTeam from '../sections/meet-the-team';
import Readmore from '../sections/product-readmore';

if (document.body.classList.contains('template-page')) {
  if (document.body.id === 'about-us') {
    charity().init();
    meetTheTeam().init();

    Readmore().init();
    katiesStory().init();

    load('*');
  }
}
